import type { MessageHandlerResult } from "@/services/abstract/poc/MessagingService";
import type { HeliaNode } from "@/types/poc/helia";
import type { LibP2pWithServices } from "@/types/poc/libp2p";
import type { MessageHandler, MessagePayload } from "@/types/poc/message";
import { createLogger, type Logger } from "@/utils/logger";

const log: Logger = createLogger({ namespace: 'six3ro:p2p:handlers:file-replication-progress' });

type FileReplicationProgressVariant = Extract<MessageHandlerResult, { type: 'file-replication-progress' }>;

export const createFileReplicationProgressHandler = (): MessageHandler<FileReplicationProgressVariant> => ({
  canHandle: (_topic: string, message: MessagePayload): boolean =>
    message.type === 'file-replication-progress',

  process: (
    message: MessagePayload,
    _libp2p: LibP2pWithServices,
    _heliaNode: HeliaNode | null
  ): FileReplicationProgressVariant => {
    if (message.type !== 'file-replication-progress') {
      throw new Error(`Invalid message type: expected 'file-replication-progress', got '${message.type}'`);
    }

    const { cid, sixId, stage, bytesTransferred, totalBytes, targetPeerId, sender, timestamp } = message;
    log.info('Received file-replication-progress for CID:', cid, 'sixId:', sixId, 'stage:', stage, 'from', sender);

    return {
      type: 'file-replication-progress',
      data: {
        cid,
        sixId,
        stage,
        bytesTransferred,
        totalBytes,
        targetPeerId,
        sender,
        messageTimestamp: timestamp,
      },
    };
  }
});
